import { AuthContext } from "@/context/authContext";
import { useContext } from "react";
import profile from "@/public/image/etc/icon_user.png"
import { SignContext } from "@/context/signContext";
import change_icon from "@/public/icon/change_icon.png"
import packageJson from "../../package.json";

export default function ProfileLayout() {
    const { user }  = useContext(AuthContext)
    const { setChangeProfileShow }  = useContext(SignContext)
    if(!user.is_authenticated) return null;

    return (
        <div className={`profile-layout-wrapper cursor-pointer`} onClick={e=> setChangeProfileShow(true)}>
            <div className="profile-layout">
                <img src={user.profile_image_url || profile.src} alt="user"
                    onError={(e) => {
                        e.currentTarget.onerror = null; // 무한 루프 방지
                        e.currentTarget.src = profile.src;
                    }} />
            </div>
            <img src={`${change_icon.src}?v=${packageJson.version}`}  className={`changeIcon`} />
        </div>
    )
}